import { LocationProps } from '../interfaces/LocationProps';
import { MarkdownFileNode } from '../interfaces/MarkdownFileNode';
import { getKindergartenByPathname } from './GetKindergartenByPathname';

export const findKindergartenNodeByAllMarkdownRemark = (
  nodes: MarkdownFileNode[],
  location: LocationProps,
): MarkdownFileNode | undefined => {
  return nodes.find((node) => {
    return node.fileAbsolutePath?.includes(getKindergartenByPathname(location.pathname));
  });
};
